import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { lazy, Suspense } from "react";
import PoliticaPrivacidad from "./PoliticaPrivacidad";

const DashboardApp = lazy(() => import("./frontend-dashboard/App"));
const ProApp = lazy(() => import("./frontend-cloud/src/App"));

function App() {
  return (
    <Router>
      <Suspense fallback={<div role="status">Cargando…</div>}>
      <Routes>
        {/* Redirigir root → /clientes */}
        <Route path="/" element={<Navigate to="/dashboard" />} />

        {/* Dashboard en /clientes */}
        <Route path="/dashboard/*" element={<DashboardApp />} />

        {/* Agenda pública en /pro */}
         <Route path="/negocio/*" element={<ProApp />} />

         {/* Política de privacidad (página pública) */}
        <Route path="/politica-privacidad" element={<PoliticaPrivacidad />} />
      </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
